<template>
  <div
    class="bg-background-neutral-secondary flex items-center justify-between space-x-2 rounded-2xl px-4 py-3"
  >
    <div class="space-y-0.5">
      <h3 class="text-text-neutral-primary text-base font-semibold">
        {{ title }}
      </h3>
      <p class="text-text-neutral-quaternary text-sm">{{ description }}</p>
      <p
        v-if="additionalDescription"
        class="text-text-neutral-quaternary text-sm"
      >
        {{ additionalDescription }}
      </p>
    </div>
    <FreeCounter
      :is-max-disabled="passengerState.isMaxDisabled"
      :is-min-disabled="passengerState.isMinDisabled"
      :counter="passengerState.amount"
      @onDisabledClick="emit('onError', $event)"
      @onChange="emit('onPassengersAmountChange', $event)"
    />
  </div>
</template>

<script setup lang="ts">
  import { FreeCounter } from 'freedom-shared';
  import type { PassengerEntity } from 'shared';

  defineProps<{
    title: string;
    description: string;
    passengerState: PassengerEntity;
    additionalDescription?: string;
  }>();

  const emit = defineEmits<{
    (e: 'onPassengersAmountChange', amount: number): void;
    (e: 'onError', type: string): void;
  }>();
</script>
